// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2EdVL","modalFooterButton":"ModalNotes_modalFooterButton__G6CxK"};